import { indexData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '热门': 'bg-primary-100 text-primary-700',
  '精选': 'bg-accent-100 text-accent-700',
  '爆款': 'bg-primary-100 text-primary-700',
  '推荐': 'bg-secondary-100 text-secondary-700',
  '深度': 'bg-accent-100 text-accent-700',
  '专题': 'bg-secondary-100 text-secondary-700',
  '趣味': 'bg-accent-100 text-accent-700',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500">精选专题内容，一站式深度吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group bg-background-50 rounded-xl p-5 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className={`px-2 py-0.5 rounded text-[11px] font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}篇</span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 line-clamp-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2">{item.desc}</p>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexData.slice(4, 7).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group bg-background-50 rounded-xl p-5 border border-background-200 hover:border-primary-200 transition-all cursor-pointer flex items-center gap-4"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`px-2 py-0.5 rounded text-[11px] font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}篇</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}